"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _index = require("../../../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HiddenCheckbox = _styled["default"].input(_index.everything);
HiddenCheckbox.defaultProps = {
  display: 'none',
  type: 'checkbox'
};
var _default = HiddenCheckbox;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJIaWRkZW5DaGVja2JveCIsInN0eWxlZCIsImlucHV0IiwiZXZlcnl0aGluZyIsImRlZmF1bHRQcm9wcyIsImRpc3BsYXkiLCJ0eXBlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZm9ybS9DaGVja2JveC9IaWRkZW5DaGVja2JveC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IGV2ZXJ5dGhpbmcgfSBmcm9tICcuLi8uLi8uLi9pbmRleCc7XG5cbmNvbnN0IEhpZGRlbkNoZWNrYm94ID0gc3R5bGVkLmlucHV0KGV2ZXJ5dGhpbmcpO1xuXG5IaWRkZW5DaGVja2JveC5kZWZhdWx0UHJvcHMgPSB7XG4gIGRpc3BsYXk6ICdub25lJyxcbiAgdHlwZTogJ2NoZWNrYm94Jyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhpZGRlbkNoZWNrYm94O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTtBQUVBO0FBQTRDO0FBRTVDLElBQU1BLGNBQWMsR0FBR0Msa0JBQU0sQ0FBQ0MsS0FBSyxDQUFDQyxpQkFBVSxDQUFDO0FBRS9DSCxjQUFjLENBQUNJLFlBQVksR0FBRztFQUM1QkMsT0FBTyxFQUFFLE1BQU07RUFDZkMsSUFBSSxFQUFFO0FBQ1IsQ0FBQztBQUFDLGVBRWFOLGNBQWM7QUFBQSJ9